import request from '@/api/request'

//PC社团-登录
export function login(data) {
  return request({
    url: '/corporation/login',
    method: 'POST',
    data: data
  })
}



///PC社团-企业列表
export function companyList(data) {
  return request({
    url: '/web/relation.enterprise/companyList',
    method: 'GET',
    params: data
  })
}

//PC社团-创建社团
export function corporationAdd(data) {
  return request({
    url: '/web/corporation/add',
    method: 'POST',
    data
  })
}

//PC社团-社团列表AAAAA
export function corporationList(data) {
  return request({
    url: '/corporation/list',
    method: 'GET',
    params: data
  })
}


//PC社团-成员列表
export function corporationUserList(data) {
  return request({
    url: '/corporation/user/list',
    method: 'GET',
    params: data
  })
}

//PC社团-角色设置
export function corporationRoleStore(data) {
  return request({
    url: '/corporation/role/store',
    method: 'POST',
    data
  })
}


//PC社团-移出人员
export function corporationExportUser(data) {
  return request({
    url: '/corporation/export/user',
    method: 'POST',
    data
  })
}

//PC社团-权限列表
export function corporationUserRoleList(data) {
  return request({
    url: '/corporation/user/role/list',
    method: 'GET',
    params: data
  })
}

//PC社团-权限设置
export function corporationUserRoleStore(data) {
  return request({
    url: '/corporation/user/role/store',
    method: 'POST',
    data
  })
}

///PC社团-职位列表
export function corporationUserJobList(data) {
  return request({
    url: '/corporation/user/job/list',
    method: 'GET',
    params: data
  })
}


///corporation/user/address/list
//PC社团-面试地址列表
export function corporationUserAddressList(data) {
  return request({
    url: '/corporation/user/address/list',
    method: 'GET',
    params: data
  })
}

//PC社团-邀请面试
export function corporationUserJobInvite(data) {
  return request({
    url: '/corporation/user/job/invite',
    method: 'POST',
    data
  })
}

///corporation/old/list
//PC社团-人员历史记录
export function corporationOldList(data) {
  return request({
    url: '/corporation/old/list',
    method: 'GET',
    params: data
  })
}

//PC社团-历史提交记录
export function corporationCorporOldList(data) {
  return request({
    url: '/corporation/corpor/old/list',
    method: 'GET',
    params: data
  })
}//

//PC社团-我加入的社团列表

export function corporationCorporJoinList(data) {
  return request({
    url: '/corporation/corpor/join/list',
    method: 'GET',
    params: data
  })
}//


//PC社团-我加入的社团详情
export function corporationInfo(data) {
  return request({
    url: '/corporation/info',
    method: 'GET',
    params: data
  })
}

export function corporationDetail(data) {
  return request({
    url: '/corporation/detail',
    method: 'GET',
    params: data
  })
}



export function corporationUpdate(data) {
  return request({
    url: '/corporation/update',
    method: 'POST',
     data
  })
}

//PC社团-发布招标
export function corporationCrowdAdd(data) {
  return request({
    url: '/corporation/crowd/add',
    method: 'POST',
    data
  })
}//

//PC社团-众包详情
export function corporationCrowdInfo(data) {
  return request({
    url: '/corporation/crowd/info',
    method: 'GET',
    params: data
  })
}//

// 众包历史记录
export function crowdsourcingHistory(data){
  return request({
    url:'/corporation/crowd/old/list',
    method:"GET",
    params:data
  })
}

///PC社团-项目列表
export function corporationProjectList(data) {
  return request({
    url: '/corporation/project/list',
    method: 'GET',
    params: data
  })
}
//PC社团-众包列表
export function corporationCrowdList(data) {
  return request({
    url: '/corporation/crowd/list',
    method: 'GET',
    params: data
  })
}


//PC社团-众包修改
export function corporationCrowdCancel(data) {
  return request({
    url: '/corporation/crowd/cancel',
    method: 'POST',
    data
  })
}

//PC社团-选标/淘汰
export function corporationCrowdClick(data) {
  return request({
    url: '/corporation/crowd/click',
    method: 'POST',
    data
  })
}

//PC社团-我投递的众包列表
export function crowdBidList(data) {
  return request({
    url: '/corporation/crowd/bid/list',
    method: 'GET',
    params:data
  })
}

//PC社团-投标详情
export function corporationCrowdBidInfo(data) {
  return request({
    url: '/corporation/crowd/bid/info',
    method: 'GET',
    params:data
  })
}




//PC社团-好友列表
export function corporationUserFriend(data) {
  return request({
    url: '/corporation/user/friend',
    method: 'GET',
    params: data
  })
}

//PC社团-粉丝列表
export function corporationUserFans(data) {
  return request({
    url: '/corporation/user/fans',
    method: 'GET',
    params: data
  })
}


//PC社团-关注列表
export function corporationUserFollow(data) {
  return request({
    url: '/corporation/user/follow',
    method: 'GET',
    params: data
  })
}
////
//PC社团-邀请人员
export function corporationInvite(data) {
  return request({
    url: '/corporation/invite',
    method: 'POST',
    data
  })
}

//PC社团-邀请我的社团列表
export function corporationinviteMyList(data) {
  return request({
    url: '/corporation/inviteMy/list',
    method: 'GET',
    params: data
  })
}


//PC社团-邀请人员同意/拒绝
export function corporationinviteMyUpdate(data) {
  return request({
    url: '/corporation/inviteMy/update',
    method: 'POST',
    data
  })
}

//PC社团-全部众包列表
export function corporationCrowdIndexList(data) {
  return request({
    url: '/corporation/crowd/index/list',
    method: 'GET',
    params: data
  })
}

//PC社团-全部众包详情
export function corporationCrowdIndexInfo(data) {
  return request({
    url: '/corporation/crowd/index/info',
    method: 'GET',
    params: data
  })
}

//PC社团-众包投标
export function corporationCrowdIndexHurl(data) {
  return request({
    url: '/corporation/crowd/index/hurl',
    method: 'POST',
    data
  })
}